import React, { useMemo, MouseEvent } from 'react';

import { JKName } from '../../../../components/JKName';
import { useOfferContext } from '../../../../context';
import { getCommercialBSCTitle } from '../../../../utils/computedProps/commercial/getCommercialBSCTitle';

export function CommercialAddressContainer() {
  const { offer, tracking } = useOfferContext();

  const bsc = getCommercialBSCTitle(offer);

  const handleClick = useMemo(() => {
    if (!bsc?.url) {
      return undefined;
    }

    return (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      tracking.trackJKLinkClicked(offer);
    };
  }, [tracking.trackJKLinkClicked, offer, bsc?.url]);

  if (!bsc) {
    return null;
  }

  return <JKName name={bsc.text} url={bsc.url} solid={false} onClick={handleClick} />;
}

CommercialAddressContainer.displayName = 'CommercialAddressContainer';
